import React from 'react'
import PropTypes from 'prop-types'
import { FormInput, Margin, Text } from 'shared/components'
import { EditableFormPanel } from 'routes/shared/components'

import * as styles from './styles'
import { getOptionLabel, getOptionValue } from './helpers'

const EditTeamsFormComponent = ({
  header,
  loadCategories,
  loadJurisdictionList,
  form,
  onSubmitRequest,
}) => {
  return (
    <EditableFormPanel header={header} form={form} onSubmit={onSubmitRequest}>
      {(editable) => (
        <>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Name
            </Text>
            <FormInput
              strictLong
              name="teamName"
              placeholder="Team Name"
              css={styles.control}
              disabled={!editable}
            />
          </Margin>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Team Website
            </Text>
            <FormInput
              strictLong
              name="teamWebsite"
              placeholder="Team Website"
              css={styles.control}
              disabled={!editable}
            />
          </Margin>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Sport
            </Text>
            <FormInput
              strictLong
              cacheOptions
              defaultOptions
              isSearchable={false}
              getOptionLabel={getOptionLabel}
              getOptionValue={getOptionValue}
              type="async-select"
              name="sport"
              placeholder="Sport"
              loadOptions={loadCategories}
              css={styles.control}
              disabled={!editable}
            />
          </Margin>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Jurisdiction
            </Text>
            <FormInput
              strictLong
              cacheOptions
              defaultOptions
              isSearchable={false}
              getOptionLabel={getOptionLabel}
              getOptionValue={getOptionValue}
              type="async-select"
              name="jurisdiction"
              placeholder="Jurisdiction"
              loadOptions={loadJurisdictionList}
              css={styles.control}
              disabled={!editable}
            />
          </Margin>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Logo
            </Text>
            <FormInput
              strictLong
              name="logo"
              placeholder="Logo"
              css={styles.control}
              disabled={!editable}
            />
          </Margin>
          <FormInput name="id" type="hidden" />
        </>
      )}
    </EditableFormPanel>
  )
}

EditTeamsFormComponent.propTypes = {
  form: PropTypes.shape(),
  header: PropTypes.string.isRequired,
  initialValues: PropTypes.shape(),
  getOptionLabel: PropTypes.func,
  getOptionValue: PropTypes.func,
  loadCategories: PropTypes.func,
  onSubmitRequest: PropTypes.func,
  loadJurisdictionList: PropTypes.func,
}

export default EditTeamsFormComponent
